import React, { useEffect, useState } from "react";
import TeamInfoForm from "./TeamInfoForm.component";
import TeamInfoCard from "./TeamInfoCard.component";

const SwitchTeamInfoAndEdit = ({ _data, handelUpdateCardData }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isNewFields, setIsNewFields] = useState(false);
  const updateData = (val) => {
    handelUpdateCardData(val);
    console.log("val", val);
    setIsEdit(false);
  };
  useEffect(() => {
    if (
      _data?.teamId === "" ||
      _data?.teamName === "" ||
      _data?.teamMembers.length === 0 ||
      _data?.teamMembers.length < 1
    ) {
      setIsEdit(true);
      setIsNewFields(true);
    } else {
      setIsEdit(false);
      setIsNewFields(false);
    }
  }, [_data]);

  return isEdit ? (
    <TeamInfoForm
      _data={_data}
      isEdit={
        _data?.teamId !== "" ||
        _data?.teamName !== "" ||
        _data?.teamMembers?.length !== 0
      }
      isNewFields={isNewFields}
      outPutData={(val) => updateData(val)}
    />
  ) : (
    <TeamInfoCard _data={_data} onEdit={() => setIsEdit(true)} />
  );
};

export default SwitchTeamInfoAndEdit;
